import { requestCallHistorySync } from '../services/callHistorySync';
import { showToast } from '../utils/toast';
import { showError } from '../utils/feedback';
import type { CallEndInfo } from './callTypes';
import type { ActiveCall, IncomingCall } from '../store/callStore';
import { compactServerUrlForLink } from '../utils/serverKey';

type CreateCallEffectsParams = {
  markCallEndedInHistory: (params: {
    callSessionId: string;
    activeCall?: ActiveCall | null;
    incomingCall?: IncomingCall | null;
    reason?: string;
    source?: CallEndInfo['source'];
    durationSeconds?: number;
  }) => void;
  getActiveCallDurationSeconds: () => number | undefined;
  consumePendingPostCallJoin: (callSessionId: string) => { inviteToken: string; serverUrl: string } | null;
  navigate: (to: string) => void;
};

export function createCallEffects(params: CreateCallEffectsParams) {
  return {
    showEndedToast() {
    },

    showStartFailed(error: unknown) {
      const message =
        error instanceof Error
          ? error.message
          : typeof error === 'string'
            ? error
            : 'Unknown error';
      showError(message);
    },

    showKeysNotReady(message: string) {
      showToast({
        message,
        variant: 'warning',
        durationMs: 6000
      });
    },

    showAnswerFailed(message: string) {
      showToast({
        message,
        variant: 'error',
        durationMs: 9000
      });
    },
    markIncomingRejected(callSessionId: string) {
      void callSessionId;
      return requestCallHistorySync();
    },

    markCallEnded(callSessionId: string, info?: {
      activeCall?: ActiveCall | null;
      incomingCall?: IncomingCall | null;
      reason?: string;
      source?: CallEndInfo['source'];
    }) {
      params.markCallEndedInHistory({
        callSessionId,
        activeCall: info?.activeCall,
        incomingCall: info?.incomingCall,
        reason: info?.reason,
        source: info?.source,
        durationSeconds: params.getActiveCallDurationSeconds()
      });
    },

    handlePostCallJoin(callSessionId: string) {
      const pendingJoin = params.consumePendingPostCallJoin(callSessionId);
      if (!pendingJoin) return;
      const server = compactServerUrlForLink(pendingJoin.serverUrl) || pendingJoin.serverUrl;
      const inviteUrl = `/open?type=circle-invite&token=${encodeURIComponent(pendingJoin.inviteToken)}&server=${encodeURIComponent(server)}`;
      window.setTimeout(() => {
        params.navigate(inviteUrl);
      }, 50);
    }
  };
}
